import React from "react";
import { TABLE_FONT as FONT, ACCENT_COLOR as ACCENT } from "../../reportTableConfig";


export const FILTER_OP_ENTRIES = [
  { op: "gt",  sym: ">",  label: "Greater than" },
  { op: "gte", sym: "≥",  label: "At least" },
  { op: "lt",  sym: "<",  label: "Less than" },
  { op: "lte", sym: "≤",  label: "At most" },
  { op: "eq",  sym: "=",  label: "Equal to" },
  { op: "neq", sym: "≠",  label: "Not equal to" },
];

export const NUMERIC_FILTER_CONTENT_WIDTH = 240;
export const NUMERIC_FILTER_PANEL_WIDTH = NUMERIC_FILTER_CONTENT_WIDTH + 24;

export function getOpSymbol(op) {
  return FILTER_OP_ENTRIES.find((e) => e.op === op)?.sym || ">";
}

export const fpBase = {
  position: "fixed",
  zIndex: 9999,
  background: "#fff",
  border: "1px solid #E2E8F0",
  borderRadius: 8,
  boxShadow: "0 8px 24px rgba(0,0,0,0.13)",
  padding: "12px",
  minWidth: 220,
};

export const fpLbl = {
  fontSize: 10,
  fontWeight: 700,
  color: "#6B7280",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  fontFamily: FONT,
  marginBottom: 8,
  display: "block",
};

export const fpTxtI = {
  width: "100%",
  boxSizing: "border-box",
  height: 28,
  border: "1.5px solid #CBD5E1",
  borderRadius: 5,
  padding: "0 8px",
  fontSize: 12,
  color: "#374151",
  fontFamily: FONT,
  outline: "none",
};

export const fpNumI = {
  flex: 1,
  height: 28,
  border: "1.5px solid #CBD5E1",
  borderRadius: 5,
  padding: "0 8px",
  fontSize: 12,
  color: ACCENT,
  fontFamily: FONT,
  outline: "none",
  minWidth: 0,
};

export const fpOpBt = {
  width: 28,
  height: 28,
  border: "1.5px solid #CBD5E1",
  borderRadius: 5,
  background: "#fff",
  color: ACCENT,
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  fontFamily: FONT,
};

export const fpClr = {
  marginTop: 8,
  fontSize: 11,
  color: "#94A3B8",
  cursor: "pointer",
  background: "none",
  border: "none",
  padding: 0,
  fontFamily: FONT,
  textDecoration: "underline",
  display: "block",
};

export const opDropS = {
  position: "fixed",
  zIndex: 10000,
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
  overflow: "hidden",
  minWidth: 160,
};

export const opItm = (active) => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "7px 12px",
  fontSize: 12,
  cursor: "pointer",
  fontFamily: FONT,
  background: active ? "#F5F3FF" : "transparent",
  color: active ? ACCENT : "#374151",
  fontWeight: active ? 600 : 400,
});

export function TextFilterContent({
  label,
  value = "",
  onChange,
  onClear,
  placeholder = "Search…",
  autoFocus = true,
  width = 220,
}) {
  return (
    <div style={{ width }}>
      {label && <span style={fpLbl}>{label}</span>}
      <input
        type="text"
        autoFocus={autoFocus}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={fpTxtI}
      />
      {value && (
        <button type="button" style={fpClr} onClick={onClear}>
          Clear filter
        </button>
      )}
    </div>
  );
}

export function NumericFilterContent({
  label,
  value = "",
  op = "gt",
  onValueChange,
  onClear,
  onToggleOp,
  opBtnRef,
  autoFocus = true,
  width = NUMERIC_FILTER_CONTENT_WIDTH,
}) {
  return (
    <div style={{ width }}>
      {label && <span style={fpLbl}>{label}</span>}
      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
        <button
          type="button"
          data-op-btn
          ref={opBtnRef}
          style={fpOpBt}
          onClick={onToggleOp}
        >
          {getOpSymbol(op)}
        </button>
        <input
          type="number"
          autoFocus={autoFocus}
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          style={fpNumI}
        />
      </div>
      {value && (
        <button type="button" style={fpClr} onClick={onClear}>
          Clear filter
        </button>
      )}
    </div>
  );
}

export function OpDropdownContent({ activeOp = "gt", onSelect, style }) {
  return (
    <div data-op-dd style={{ ...opDropS, ...style }}>
      {FILTER_OP_ENTRIES.map((e) => (
        <div
          key={e.op}
          style={opItm(activeOp === e.op)}
          onMouseDown={() => onSelect(e.op)}
        >
          <span style={{ width: 20, textAlign: "center", fontWeight: 700 }}>{e.sym}</span>
          {e.label}
        </div>
      ))}
    </div>
  );
}
